import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';
import Tracker from '../../domain/tracker/Tracker';
import TrackerSchema from '../../domain/tracker/TrackerSchema';

export type TrackerActions = 'CHANGE_TRACKER' | 'CHANGE_TRACKER_IS_UPDATE' | 'CLEAR_TRACKER' | 'CHANGE_TRACKER_SCHEMA' | 'CHANGE_TRACKER_DIRTY';

export const changeTracker = (payload: Tracker) =>
  ({
    type: 'CHANGE_TRACKER',
    payload,
  }) as ReduxBaseAction<Tracker | null, TrackerActions>;

export const changeTrackerSchema = (payload: TrackerSchema | null) =>
  ({
    type: 'CHANGE_TRACKER_SCHEMA',
    payload,
  }) as ReduxBaseAction<TrackerSchema | null, TrackerActions>;

export const changeTrackerIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_TRACKER_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean | null, TrackerActions>;

export const clearTracker = () =>
  ({
    type: 'CLEAR_TRACKER',
    payload: void 0,
  }) as ReduxBaseAction<any, TrackerActions>;

export const changeTrackerDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_TRACKER_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, TrackerActions>;
